export class AttributionEditor {
    private static setStartAttributionMessage = (resourceType: string) => {
        const resourceTypes: Record<string, unknown> = {
            icon: messages.attribution.icons_made_by,
            sticker: messages.attribution.stickers_made_by,
            standard: messages.attribution.icons_made_by,
        };

        return resourceTypes[resourceType];
    };

    private static copyContentAttribution = () => {
        const attributionCopyLink = document.getElementById('input_atributtion_text_modal_copyLink') as HTMLInputElement;
        attributionCopyLink.select();
        document.execCommand('copy');
    };

    private static resetCopyButtons = () => {
        const copyButton = document.querySelector('.modal-download #copy-attributtion') as HTMLElement;

        if (copyButton.children[1].classList.contains('active')) {
            copyButton.children[0].classList.add('active');
            copyButton.children[1].classList.remove('active');
        }
    };

    private static handlerCopyAttribution = () => {
        (document.querySelector('.fi-modal #copy-attributtion') as HTMLElement).addEventListener('click', (e: Event) => {
            const currentElement = e.currentTarget as HTMLElement;

            currentElement.children[0].classList.remove('active');
            currentElement.children[1].classList.add('active');
            AttributionEditor.copyContentAttribution();
            AttributionEditor.copyContentAttribution();
        });
    };

    public static setUpModalFreeDownload = async () => {
        let licence: string;
        const modal = document.querySelector('.fi-modal.modal-download') as HTMLElement;
        const downloadForm = document.getElementById('download-form') as HTMLFormElement;
        AttributionEditor.handlerCopyAttribution();
        AttributionEditor.resetCopyButtons();

        if (downloadForm) {
            const iconInfo = document.querySelector('#detail') ? document.getElementById('detail') : document.getElementById('detail-content');

            modal.querySelector('.modal-collection')?.classList.add('hidden');
            modal.querySelector('.modal-pack')?.classList.add('hidden');

            let description = iconInfo?.querySelector('h1 .title')?.innerHTML || '';

            (modal.querySelector('.filename .description') as HTMLElement).innerHTML = description;

            let mainImg = iconInfo?.querySelector('.main-icon img') as HTMLImageElement;

            if (!mainImg) {
                mainImg = iconInfo?.querySelector('.main-icon-without-slide img') as HTMLImageElement;
            }

            let iconImage = new Image();
            if (modal.querySelector('p.filename .icon-holder img')) {
                iconImage = modal.querySelector('p.filename .icon-holder img') as HTMLImageElement;
            }

            iconImage.src = mainImg.src;
            iconImage.classList.add('replaced-svg');
            iconImage.alt = description;

            let iconHolder = modal.querySelector('p.filename .icon-holder') as HTMLElement;
            iconHolder.insertAdjacentElement('afterbegin', iconImage);

            const author = {
                link: iconInfo?.querySelector('#author-url') as HTMLInputElement,
                title: (iconInfo?.querySelector('.author .username') as HTMLElement).title,
                img: iconInfo?.querySelector('.author .avatar img') as HTMLImageElement,
            };

            let avatarImage = new Image();
            if (modal.querySelector('p.author img')) {
                avatarImage = modal.querySelector('p.author img') as HTMLImageElement;
            }
            avatarImage.src = author.img.src;
            avatarImage.classList.add('avatar');

            let avatarHolder = modal.querySelector('p.author') as HTMLElement;
            avatarHolder.insertAdjacentElement('afterbegin', avatarImage);

            (modal.querySelector('.author .description') as HTMLElement).innerHTML = `By ${author.title}`;

            licence = `<div> ${AttributionEditor.setStartAttributionMessage(iconInfo?.dataset.icon_type || 'standar')} <a href="${author.link.value}" title="${
                author.title
            }"> ${author.title} </a> from <a href="${APP_URL}" title="Flaticon">${window.location.host}'</a></div>`;

            (modal.querySelector('.copy-holder span') as HTMLSpanElement).textContent = licence;
            (modal.querySelector('.input_atributtion_text') as HTMLTextAreaElement).setAttribute('value', licence);
        }
    };
}
